import { ErrorBoundary, NoAccess } from "@neonumy/ant-design";
import { APP_URLS } from "@neonumy/api-clients";
import { lazy } from "react";
import { createBrowserRouter, createRoutesFromElements, Route } from "react-router-dom";
import CompanySelectionCard from "../../components/CompanySelectionCard";
import DeprecatedRouteRedirect from "./DeprecatedRouteRedirect";
import PrivateRoute from "./PrivateRoute";

const Page404 = lazy(() => import("views/Base/Page404"));
const ContentPage = lazy(() => import("views/Base/ContentPage"));
const BankAccounts = lazy(() => import("views/Banks/BankAccounts"));
const BankAccountForm = lazy(() => import("views/Banks/BankAccountForm"));

const routers: ReturnType<typeof createBrowserRouter> = createBrowserRouter(
  createRoutesFromElements(
    <>
      <Route
        path="/"
        element={
          <ErrorBoundary>
            <PrivateRoute />
          </ErrorBoundary>
        }
      >
        <Route index element={<CompanySelectionCard />} />
        <Route path="/accounting-firm/:accountingFirmId" element={<CompanySelectionCard />} />

        <Route
          path="/accounting-firm/:accountingFirmId/company/:companyId"
          element={<DeprecatedRouteRedirect />}
        />

        <Route path="/company/:companyId" element={<ContentPage />}>
          <Route path=":menu" element={<ContentPage />} />

          <Route path=":menu" element={<ContentPage />}>
            <Route path=":bankId/bank-accounts">
              <Route index element={<BankAccounts />} />
              <Route path=":bankAccountId" element={<BankAccountForm />} />
            </Route>
          </Route>
        </Route>
        <Route path="*" element={<Page404 />} />
      </Route>
      <Route path="no-access" element={<NoAccess dashboardUrl={APP_URLS.dashboardUrl} />} />
    </>,
  ),
  {
    future: {
      v7_relativeSplatPath: true,
      v7_fetcherPersist: true,
      v7_normalizeFormMethod: true,
      v7_partialHydration: true,
      v7_skipActionErrorRevalidation: true,
    },
  },
);

export { routers };
